/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Source_Explicit_UserInputs */



/**
* | output |
* | --- |
* | "Explicit user override" |
*
* @param {Rights_Source_Explicit_UserInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_source_explicit_user = /** @type {((inputs?: Rights_Source_Explicit_UserInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Source_Explicit_UserInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Explizite Nutzer-Ausnahme")
	return /** @type {LocalizedString} */ ("Explicit user override")
});